import { defineFormSchema } from '../../../shared/data/formSchema';
import {
  EXPENSE_TYPE_FORM_OPTIONS,
  EXPENSE_RECIPIENT_TYPE_OPTIONS,
  RECURRING_OPTIONS,
  INVOICE_PAYMENT_TYPE_OPTIONS,
  PAYMENT_STATUS_OPTIONS,
  EXPENSE_STATUS_OPTIONS,
} from '../utils/accounting.constants';

export const expenseFormSchema = defineFormSchema({
  id: 'accounting.expense.create',
  fields: [
    {
      name: 'description',
      label: 'Titolo',
      required: true,
      primary: true,
      table: { header: 'Movimento', minWidth: 190, order: 0 },
    },
    {
      name: 'type',
      label: 'Tipo di Spesa',
      type: 'select',
      required: true,
      options: EXPENSE_TYPE_FORM_OPTIONS,
      table: { order: 2 },
    },
    {
      name: 'amount',
      label: 'Importo',
      type: 'currency',
      required: true,
      table: { direction: 'expense', order: 90 },
    },
    { name: 'dueDate', label: 'Data Scadenza', type: 'date', required: true, table: { order: 1 } },
    {
      name: 'recurring',
      label: 'Ricorrenza',
      type: 'select',
      options: RECURRING_OPTIONS,
      table: { order: 5 },
    },
    {
      name: 'recipientType',
      label: 'Destinatario',
      type: 'select',
      options: EXPENSE_RECIPIENT_TYPE_OPTIONS,
      table: { hidden: true },
    },
    { name: 'recurrenceCount', label: 'Numero ricorrenze / rate', type: 'number', table: { order: 6 } },
    { name: 'staffId', label: 'Membro staff', required: true, table: false },
    { name: 'supplierId', label: 'Fornitore', required: true, table: false },
    { name: 'paymentDate', label: 'Pagamento', type: 'date', readOnly: true, table: { order: 4 } },
    {
      name: 'status',
      label: 'Stato',
      type: 'select',
      options: EXPENSE_STATUS_OPTIONS,
      readOnly: true,
      table: { order: 6 },
    },
  ],
});

export const invoiceFormSchema = defineFormSchema({
  id: 'accounting.invoice.create',
  fields: [
    { name: 'installments.amount', label: 'Importi rate', type: 'currency', table: false, filter: { accessor: (row) => row.installments?.map((item) => item.amount) } },
    { name: 'installments.dueDate', label: 'Scadenze rate', type: 'date', table: false, filter: { accessor: (row) => row.installments?.map((item) => item.dueDate) } },
    { name: 'invoiceNumber', label: 'Numero Fattura', primary: true, table: { minWidth: 150, order: 0 } },
    { name: 'issueDate', label: 'Data Emissione', type: 'date', required: true, table: { order: 1 } },
    { name: 'clientId', label: 'Cliente', required: true, table: { accessor: 'client', order: 2 } },
    { name: 'assignment', label: 'Origine', table: { order: 3 } },
    {
      name: 'type',
      label: 'Tipo di Pagamento',
      required: true,
      type: 'select',
      options: INVOICE_PAYMENT_TYPE_OPTIONS,
      table: { hidden: true },
    },
    {
      name: 'totalAmount',
      label: 'Importo Totale',
      type: 'currency',
      required: true,
      table: { direction: 'income', order: 90 },
    },
    { name: 'paymentExpectedDate', label: 'Scadenza', type: 'date', table: { hidden: true } },
    { name: 'status', label: 'Stato', readOnly: true, table: { order: 4 } },
  ],
});

export const paymentFormSchema = defineFormSchema({
  id: 'accounting.payment',
  fields: [
    { name: 'reason', label: 'Causale', table: { hidden: true } },
    {
      name: 'description',
      label: 'Titolo',
      required: true,
      primary: true,
      table: {
        header: 'Movimento',
        accessor: (row) => row.description || row.invoiceNumber || 'Incasso',
        minWidth: 190,
        order: 0,
      },
    },
    {
      name: 'amount',
      label: 'Importo',
      type: 'currency',
      required: true,
      table: { direction: 'income', order: 90 },
    },
    { name: 'date', filter: { accessor: (row) => row.paymentDate || row.issueDate }, label: 'Data', type: 'date', required: true, table: false },
    {
      name: 'clientId',
      label: 'Cliente',
      table: {
        accessor: (row) => row.clientResolvedName || row.client || row.payerName || 'Cliente non risolto',
        order: 3,
      },
    },
    { name: 'payerName', label: 'Pagante', required: true, table: false },
    { name: 'paymentMethod', label: 'Metodo di pagamento', table: false },
    { name: 'invoiceNumber', label: 'Fattura', readOnly: true, table: { hidden: true } },
    { name: 'installment', label: 'N°', readOnly: true, table: { align: 'center', badge: true, order: 1 } },
    { name: 'assignment', label: 'Task', readOnly: true, table: { order: 4 } },
    {
      name: 'type',
      label: 'Tipo',
      type: 'select',
      options: INVOICE_PAYMENT_TYPE_OPTIONS,
      readOnly: true,
      table: { hidden: true },
    },
    { name: 'issueDate', label: 'Data emissione', type: 'date', readOnly: true, table: { hidden: true } },
    { name: 'dueDate', label: 'Scadenza', type: 'date', table: { order: 2 } },
    { name: 'paymentDate', label: 'Incasso', type: 'date', table: { order: 5 } },
    { name: 'status', label: 'Stato', type: 'select', options: PAYMENT_STATUS_OPTIONS, table: { order: 6 } },
    { name: 'notes', label: 'Note', type: 'textarea', table: { order: 80 } },
  ],
});
